import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const batchOverviewGridStyles = makeStyles((theme: Theme) =>
    createStyles({
        title: {
            color: "#525252",
            letterSpacing: "0.07em",
            textTransform: "uppercase",
            lineHeight: "120%",
        },
        text: {
            color: "#181818",
            fontWeight: 500,
        },
        grid: {
            marginTop: "10px",
            padding: "20px",
        },
    })
);
